import { base64ToArrayBuffer } from '@/utils/file/base64Helpers';

/** Mesma saída de foto web para câmera/galeria: JPEG 0,75, largura máxima 1280, sem corte ou upscale. */
export async function compressChecklistPhotoWeb(
  uri: string,
  { maxWidth = 1280, quality = 0.75 }: { maxWidth?: number; quality?: number } = {},
): Promise<string> {
  return new Promise((resolve, reject) => {
    const image = document.createElement('img');
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      try {
        let { width, height } = image;
        if (width > maxWidth) { height *= maxWidth / width; width = maxWidth; }
        const canvas = document.createElement('canvas');
        canvas.width = width; canvas.height = height;
        const context = canvas.getContext('2d');
        if (!context) throw new Error('Não foi possível preparar a foto neste navegador.');
        context.drawImage(image, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', quality).split(',')[1]);
      } catch { reject(new Error('Não foi possível preparar a foto neste navegador.')); }
    };
    image.onerror = () => reject(new Error('Não foi possível abrir a foto selecionada.'));
    image.src = uri;
  });
}

/** Adapta os mesmos bytes comprimidos para o rascunho/upload público, sem recomprimir nos retries. */
export async function prepareChecklistPhotoBlobWeb(blob: Blob): Promise<Blob> {
  const uri = URL.createObjectURL(blob);
  try {
    const base64 = await compressChecklistPhotoWeb(uri);
    return new Blob([base64ToArrayBuffer(base64)], { type: 'image/jpeg' });
  } finally { URL.revokeObjectURL(uri); }
}
